/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './defs.defs.js'

const $nsid = 'app.bsky.actor.getProfile'

export { $nsid }

/** Get detailed profile view of an actor. Does not require auth, but contains relevant metadata with auth. */
const main = l.query(
  $nsid,
  l.params({ actor: l.string({ format: 'at-identifier' }) }),
  l.payload(
    'application/json',
    l.ref<ActorDefs.ProfileViewDetailed>(
      (() => ActorDefs.profileViewDetailed) as any,
    ),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
